
import  { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SideNavbar from "../components/Sidebar";
import CsSidebar from "../components/CsSidebar";
import CAsidebar from "../components/CAsidebar";
import LegalSidebar from "../components/LegalSidebar";
import EmployeeSidebar from "../components/EmployeeSidebar";
import Navbar from "../components/DashboardNavbar";

export const useRoleLayout = () => {
  const location = useLocation();
  const [role, setRole] = useState(null);
  
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts.length >= 2 && pathParts[1]) {
      const extractedRole = pathParts[1].toLowerCase();
      if (['ca', 'cs', 'legal', 'employee'].includes(extractedRole)) {
        setRole(extractedRole.toUpperCase());
      } else {
        setRole(null);
      }
    } else {
      setRole(null);
    }
  }, [location]);
  
  const Layout = ({ children }) => {
    
    const renderSidebar = () => {
      switch(role) {
        case 'CA':
          return <CAsidebar />;
        case 'CS':
          return <CsSidebar />;
        case 'LEGAL':
          return <LegalSidebar />;
        case 'EMPLOYEE':
          return <EmployeeSidebar />;
        default:
          return <SideNavbar />;
      }
    };
    
    return (
      <>
        <div className="layout">
          <div className="container-fluid m-0 g-0 p-0">
            <div className="navbarStyle">
              <Navbar />
            </div>
            
            <div className="otherPage">
              <div>
                {renderSidebar()}
              </div>
              <div className="pages">
                {children}
              </div>
            </div>
            <div>
              {/* <Footer /> */}
            </div>
          </div>
        </div>
      </>
    );
  };
  
  return { role, Layout };
};